/* eslint-disable no-param-reassign */
export default {
  /**
  * Install the plugin
  */
  install(Vue, options) {
    Vue.prototype.$workbox = options.wb.default;
  },
};
